import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlockquote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.5 3.75a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-1.5 0v-11a.75.75 0 0 1 .75-.75m2.994 1.314a.75.75 0 0 1 .75-.75H14.5a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75m0 5.073a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75m0 5.073a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBlockquote;
